// @material-ui/icons
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun'
import DepartmentDeparturesTab from '../components/departure/department/DepartmentDeparturesTab'


export function departureRoutes(user) {
  let routes = []

  if (user.authorities.includes('DEPARTURE-TUTOREN'))
    routes = routes.concat([
      {
        path: '/dashboard/departures/tutoren',
        name: 'Auszüge Tutor',
        icon: DirectionsRunIcon,
        additionalProps: {
          department: 'tutoren',
        },
        component: DepartmentDeparturesTab,
      },
    ])
  if (user.authorities.includes('DEPARTURE-BAR'))
    routes = routes.concat([
      {
        path: '/dashboard/departures/bar',
        name: 'Auszüge Bar',
        icon: DirectionsRunIcon,
        additionalProps: {
          department: 'bar',
        },
        component: DepartmentDeparturesTab,
      },
    ])
  if (user.authorities.includes('DEPARTURE-WERK'))
    routes = routes.concat([
      {
        path: '/dashboard/departures/werk',
        name: 'Auszüge Werk',
        icon: DirectionsRunIcon,
        additionalProps: {
          department: 'werk',
        },
        component: DepartmentDeparturesTab,
      },
    ])
  if (user.authorities.includes('DEPARTURE-INNEN'))
    routes = routes.concat([
      {
        path: '/dashboard/departures/innen',
        name: 'Auszüge Innen',
        icon: DirectionsRunIcon,
        additionalProps: {
          department: 'innen',
        },
        component: DepartmentDeparturesTab,
      },
    ])
  if (user.authorities.includes('DEPARTURE-FINANZEN'))
    routes = routes.concat([
      {
        path: '/dashboard/departures/finanzen',
        name: 'Auszüge Finanz',
        icon: DirectionsRunIcon,
        additionalProps: {
          department: 'finanzen',
        },
        component: DepartmentDeparturesTab,
      },
    ])
  if (user.authorities.filter(it => it.includes('DEPARTURE-H')).length !== 0) {
    routes = routes.concat([
      {
        path: '/dashboard/departures/floor',
        name: 'Auszüge Flur',
        icon: DirectionsRunIcon,
        component: DepartmentDeparturesTab,
      },
    ])
  }

  return routes
}
